import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Wrap, Dropdown, Container } from './styled';
import { useClickAway } from './hooks/useClickAway';
export const AnimatedDropdown = ({ cta, shouldShowDropdown, children, className = 'animated-dropdown', reversed = false, onClickAway = () => { }, timeout = 350, transitionClassnames = 'dropdown', onClick, onMouseEnter, onMouseLeave, }) => {
    const dropdownRef = useRef(null);
    useClickAway(dropdownRef, (event) => {
        if (shouldShowDropdown) {
            onClickAway(event);
        }
    });
    return (React.createElement(Container, { className: `${className}-container ${className}`, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: dropdownRef },
        !reversed && cta,
        React.createElement(Wrap, { className: `${className}-wrap ${className}` },
            React.createElement(CSSTransition, { in: shouldShowDropdown, timeout: timeout, classNames: transitionClassnames, unmountOnExit: true },
                React.createElement(Dropdown, { reversed: reversed, className: `${className}-basic-dropdown ${className}` }, children))),
        reversed && cta));
};
//# sourceMappingURL=AnimatedDropdown.js.map